import { resetLevel2 } from '../level_2/reset_level_2';
import * as GAEvents from '../../google_analytics/navigation';

export const onToggleVisibilityClick = ($nav, $body, setCurrentNavLabel) => event => {
    if (event) {
        event.preventDefault();
    }

    const wasOpened = $nav.hasClass('navigation--opened');
    $nav.toggleClass('navigation--opened');
    $body.toggleClass('prevent-scroll');

    if (wasOpened) {
        resetLevel2($nav, setCurrentNavLabel);
        GAEvents.closeMobileNavigation();
    } else {
        GAEvents.openMobileNavigation();
    }
};
